import $axios from "../../api.js";

const state = () => ({
  data_order: {
    destination: "",
    product_id: "",
    price_selling: "",
  },
  data_operator_selected: {
    prabayar_category: {
      product_name: "",
    },
  },
});

const mutations = {
  SET_DATA_OPERATOR_SELECTED(state, payload) {
    state.data_operator_selected = payload;
  },
  RESET_DATA_ORDER(state) {
    state.data_order = {
      destination: "",
      product_id: "",
      price_selling: "",
    };
  },
  RESET_DATA_OPERATOR_SELECTED(state) {
    state.data_operator_selected = {
      prabayar_category: {
        product_name: "",
      },
    };
  },
};

const actions = {
  transactionOrder({ state }) {
    return new Promise((resolve, reject) => {
      $axios
        .post("/sender/request-code", state.data_order)
        .then((response) => {
          // console.log(state.sender);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
